export interface IRefinancingForm {
  propertyWorth: string;
  refinanceAmount: string;
  outstandingCurrentMortgage: string;
  extraFinancePlanning: string | null;
}

export const EXTRA_FINANCE_PLANING_OPTIONS = [
  'Home improvements or property extension',
  'Extend the lease or purchase freehold (or share of) title of the property',
  'Purchase of another property',
  'Large purchases (e.g. car, wedding expenses, healthcare)',
  'Purchase of land to extend security',
  'Increase lending to pay ERCs elsewhere',
  'Matrimonial settlement or to purchase the equity of another party to the mortgage',
  'Other',
];
